import { render } from "./PopUpAllocatePoints.vue?vue&type=template&id=1fbe7981"
import script from "./PopUpAllocatePoints.vue?vue&type=script&lang=js"
export * from "./PopUpAllocatePoints.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__